<template>
  <div
    class="material"
    draggable="true"
    @mousedown="onMouseDown"
    @dragstart="onDragStart"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ICScreenMaterial',
  props: {
    material: {
      type: Object,
      require: true
    }
  },
  methods: {
    /******* 中屏 *******/
    onMouseDown (event) {
      event.stopPropagation()
    },
    onDragStart (event) {
      const material = {
        ...this.material,
        id: Date.now(),
        title: `${this.material.title}${Date.now()}`,

        // TODO 测试使用的高度和宽度
        size: {
          width: 300,
          height: 300
        },
      }
      event.dataTransfer.setData('material', JSON.stringify(material))
      event.stopPropagation()
    }
  }
}
</script>
